import React from "react";
import { useFormikContext } from "formik";
import ToolsIcon from "../../assets/icons/Tools.svg";
import JobCalendarIcon from "../../assets/icons/JobCalnedar.svg";
import FormField from "./FormField";

const Step1 = ({ fields }) => {
  const { values, setFieldValue, errors, touched } = useFormikContext();

  return (
    <div className="grid md:grid-cols-2 md:justify-center md:gap-4 gap-2 w-full mt-4">
      {Object.values(fields).map((field) => (
        <FormField
          key={field.name}
          {...field}
          error={errors[field.name]}
          touched={touched[field.name]}
        />
      ))}
    </div>
  );
};

export default Step1;
